<template>
  <span :aria-hidden="decorative"
        :aria-label="title"
        class="material-design-icon account-icon"
        role="img">

    <svg class="material-design-icon__svg" xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="14.183 -0.062 483.634 512.079" :fill="fillColor"><path d="M497.617 84.21a89.746 89.746 0 00-2.034-20.703C486.43 24.97 454.958.036 415.005.036 308.935-.133 202.871-.085 96.814.182a83.963 83.963 0 00-26.278 4.032c-34.723 11.713-56.043 41.424-56.153 78.09-.266 76.274-.266 152.548 0 228.823.164 42.204 28.349 74.93 70.227 81.305 11.841 1.797 24.135.835 36.212.943 13.293.109 26.587 0 40.535 0-.545 5.721-.89 10.896-1.544 15.854a247.534 247.534 0 01-12.531 50.505 38.844 38.844 0 0012.331 42.604c12.949 10.896 30.709 13.003 44.875 4.213a420.522 420.522 0 0039.863-27.586c29.511-23.427 54.791-51.085 77.799-81.014a9.207 9.207 0 018.336-3.941c27.694.163 55.371.236 83.066 0a96.92 96.92 0 0021.139-2.216c34.995-8.263 63.344-39.299 63.126-81.994-.4-75.202-.055-150.405-.2-225.59zm-162.192 94.435c-5.738.327-11.514.254-17.252 0a6.555 6.555 0 00-6.175 3.396c-8.862 12.222-17.852 24.335-27.241 36.194-2.343 2.978-2.034 4.231.636 6.374a3610.355 3610.355 0 0137.266 30.383c12.113 10.043 10.751 27.24-2.634 34.977-6.755 3.924-14.655 3.088-21.901-2.705-11.713-9.316-23.3-18.814-34.922-28.24-2.58-2.088-5.322-4.031-7.683-6.356-2.742-2.669-4.74-2.088-7.718 0a2809.308 2809.308 0 01-49.469 34.396c-5.83 3.959-12.222 6.792-19.595 4.032-7.373-2.761-12.622-7.883-14.147-15.801a18.613 18.613 0 017.863-19.522c9.553-6.883 19.723-12.876 29.384-19.631 22.011-15.364 42.586-32.398 60.039-52.938.963-.999 1.834-2.216 3.523-4.395h-86.226c-8.281 0-15.273-2.688-19.613-9.988-5.91-9.447-3.042-21.896 6.404-27.806a20.173 20.173 0 0110.303-3.067c17.833-.526 35.704-.182 53.555-.2h5.866V111.07c-.199-11.402 8.882-20.807 20.284-21.006.515-.009 1.03.001 1.545.031 10.66.363 18.905 9.516 19.123 21.43.127 8.317 0 16.635.108 24.953.119.326.266.642.436.944 1.453 0 3.179.254 4.922.254 17.253 0 34.505-.091 51.739 0 12.005 0 20.631 7.573 21.684 18.342 1.162 12.022-7.519 21.937-20.104 22.627z"/></svg>

  </span>
</template>

<script>
export default {
  name: "LanguageIcon",
  props: {
    title: {
      type: String,
      default: "Language icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
}
</script>
